import { ChangeDetectionStrategy, Component, model } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { ButtonComponent } from '@examdojo/core/button';
import { emailValidator, ErrorMessages } from '@examdojo/core/form';
import { FormConfirmFn, SubmitButtonDirective } from '@examdojo/core/form-submit-button';
import { IconComponent } from '@examdojo/core/icon';
import { TextInputComponent } from '@examdojo/ui/input';
import { TopHeaderComponent } from '@examdojo/ui/top-header/top-header.component';
import { IonButton } from '@ionic/angular/standalone';
import { ExamdojoAuthService } from '../abstract-auth.service';
import { LastUsedAuthService } from '../last-used-auth.service';
import { OtpVerificationStepComponent } from '../otp-verification-step/otp-verification-step.component';

@Component({
  selector: 'dojo-sign-in-otp',
  templateUrl: './sign-in-otp.component.html',
  styleUrl: './sign-in-otp.component.scss',
  host: { class: 'flex flex-col h-full' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButtonModule,
    ReactiveFormsModule,
    IconComponent,
    TextInputComponent,
    SubmitButtonDirective,
    ButtonComponent,
    TopHeaderComponent,
    IonButton,
    OtpVerificationStepComponent,
  ],
})
export class SignInOTPComponent {
  constructor(
    private readonly authService: ExamdojoAuthService,
    private readonly router: Router,
    private readonly lastUsedAuthService: LastUsedAuthService,
  ) {}

  readonly emailErrorMessages: ErrorMessages = {
    required: 'Email is required',
    email: 'Enter a valid email',
  };

  readonly emailForm = new FormGroup(
    {
      email: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, emailValidator],
      }),
    },
    {
      updateOn: 'submit',
    },
  );

  readonly otpErrorMessages: ErrorMessages = {
    required: 'Code is required',
  };

  readonly otpCodeHasBeenSent = model(false);

  sendOTPCode(emailForm: typeof this.emailForm = this.emailForm) {
    if (emailForm.invalid) {
      emailForm.markAllAsTouched();
      return;
    }

    const { email } = emailForm.getRawValue();

    return this.authService.signInWithOTP(email);
  }

  goBack() {
    window.history.back();
  }

  readonly emailConfirmFn: FormConfirmFn<typeof this.emailForm> = async (form) => {
    const response = await this.sendOTPCode(form);

    if (!response?.error) {
      this.otpCodeHasBeenSent.set(true);
    }
  };

  handleOtpVerificationSuccess() {
    // Save email as last used method after successful OTP verification
    this.lastUsedAuthService.setLastUsedMethod('otp');
    this.router.navigate(['/'], { queryParamsHandling: 'preserve' });
  }
}
